module.exports = __webpack_public_path__ + "img/percent2.e5f3d6b9.svg";